import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Image, Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import AdherentNewUpdate from './AdherentNewUpdate';
import Tarif from './Tarif';
import PrelevementSepaForm from './PrelevementSepaForm';
import GenerePdf from './GenerePdf';
import rib from './assets/images/rib.png'; // Importez le chemin de votre image
import { quoteToDoubleQuote } from './utils/Columns';

const Adhere = () => {

    const url = localStorage.getItem('url');

    const { code, mail, success } = useParams();
    const [cotisation, setCotisation] = useState([]);
    const [cotisation2, setCotisation2] = useState({});
    const [editedAdherent, setEditedAdherent] = useState({});
    const [savedAdherent, setSavedAdherent] = useState(null);

    const [prelevementSelected, setPrelevementSelected] = useState({ nb: 0 });
    const [showTarifs, setShowTarifs] = useState(true);
    const [lienInvalide, setLienInvalide] = useState(false);
    const [lienValide, setLienValide] = useState(false);
    const [goGenerePdf, setGoGenerePdf] = useState(false);
    const [payeByCheque, setPayeByCheque] = useState(false);
    const [payeByVirement, setPayeByVirement] = useState(false);
    const [successPaiement, setSuccessPaiement] = useState(false);
    const [champs, setChamps] = useState([
        { lib: 'civilite', required: false }, { lib: 'prenom_adherent', required: true }, { lib: 'nom_adherent', required: true }, { lib: 'adresse1', required: true }, { lib: 'adresse2', required: false }, { lib: 'code_postal', required: true, longueur: 5 }, { lib: 'ville', required: true }, { lib: 'telephone', required: true }, { lib: 'numero_de_portable', required: false }, { lib: 'e_mail_1', required: true }, { lib: 'e_mail_2', required: false }, { lib: 'e_mail_3', required: false },

        { lib: 'nom_de_l_entreprise', required: true }, { lib: 'siret', required: true, longueur: 14 }, { lib: 'numero_tva_intracommunautaire', required: false }, { lib: 'code_ape_ou_naf', required: false }, { lib: 'forme_juridique_de_la_societe', required: false }, { lib: 'montant_du_capital', required: false },

        { lib: 'nbre_productifs', required: false }, { lib: 'nbre_apprentis', required: false }, { lib: 'total_personnel', required: false },

        { lib: 'acces_site_ffc_newsletter', required: false }, { lib: 'acces_site_ffc_newsletter', required: false }, { lib: 'abonne_ffc_expert', required: false }, { lib: 'abonne_mag_carrosserie', required: false }, { lib: 'abonne_profession_carrossier', required: false }, { lib: 'acces_mediateur_consommation', required: false },

        { lib: 'has_tribu', required: false },

        { lib: 'choix_id', required: true },
        { lib: 'tribu_montant', required: false },
        { lib: 'paiement_montant', required: false },

    ]);

    const nouveauChamps = champs.map(champ => {
        if (champ.lib === 'choix_id') {
            return { ...champ, required: false };
        }
        return champ;
    });
    const handleTarifSelected = (tarif) => {
        setPayeByCheque(false);
        console.log('handleTarifSelected', tarif);
        if (tarif.paiement === 'PRELEVEMENT') {
            setShowTarifs(false);
            setPrelevementSelected(tarif);
        } else if (tarif.paiement === 'VIREMENT') {
            savePaiement('VIREMENT');
            setPayeByVirement(true);
        } else if (tarif.paiement === 'CHEQUE') {
            setPayeByCheque(true);
            savePaiement('CHEQUE');
            // setGoGenerePdf(true);
        } else {
            alert('Paiement par ' + tarif.paiement + ' en ' + tarif.nb + ' fois');
        }
    }

    const savePaiement = (typePaiement) => {
        fetch(`${url}SavePaiement/${typePaiement}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
            })
            .catch(error => console.error('Erreur:', error));
    }

    const getAdherent = (donnees) => {
        if (code && code !== '')
            fetch(`${url}GetAdherentByCode/${code}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    let adh = data.data[0];
                    //iban', required: true },
                    // { lib: 'bic', required: true },
                    // { lib: 'rum
                    console.log('Réponse du serveur:', adh, donnees)
                    setEditedAdherent({ ...adh, ibantmp: '', iban: '', bictmp: '', bic: '', nb_fois: 1, code: code, type_paiement: '', cotisation_nationale_t1: adh.choix_montant });
                })
                .catch(error => console.error('Erreur:', error));
    };

    useEffect(() => {
        if (url && url !== '') {
            getData();
        }
    }, []);

    const getData = () => {
        console.log('getData');
        // Appel de l'API
        fetch(`${url}GetCotisationByCodeAndMail/${code}/${mail}`)
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0' || !data.data || data.data.length === 0)
                    setLienInvalide(true);

                else {

                    let donnees = data.data;
                    let donnee1 = donnees[0];

                    console.log('données', donnee1);
                    setLienValide(true);

                    if (donnee1.id === 10)
                        setChamps(nouveauChamps);

                    setCotisation(donnee1);
                    if (donnees.length > 1)
                        setCotisation2(donnees[1]);

                    // has_filled, has_selected_paiement, montant,montant_ffc,montant_tribu,tribu,nb_fois
                    if (donnee1.has_filled === 1) {
                        getAdherent(donnee1);

                        // setEditedAdherent(adh);
                    }
                    // alert('Lien valide');
                }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const handlPrelevementSuccess = () => {
        setSuccessPaiement(true);
    }

    const handleSaveAdherent = (editedAdh) => {
        let adhe = { ...editedAdh, appel_cotisation_id: cotisation.appel_cotisation_id };
        fetch(`${url}SaveDonneesAdherent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            // remplace 'Invalid date' par '' dans le JSON
            body: JSON.stringify(quoteToDoubleQuote(adhe)).replace(/"Invalid date"/g, '""')
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                setEditedAdherent(adhe);
                setSavedAdherent(adhe);
                // handleNextTab();

            })
            .catch(error => console.error('Erreur:', error));
    }

    const modifAdherent = () => {
        //editedAdherent sans appel_cotisation_id
        setSavedAdherent({ ...editedAdherent });
        setEditedAdherent({});
    }

    const blocs = ['infoAdhWaiting', 'entreprise', 'effectif', 'abonnement_visualisation', 'cotisation_new_adherent'];


    return (
        <div>
            <h1>Bienvenue dans la page d'adhésion à la FFC Mobilité</h1>
            {/* {successPaiement?'successPaiement': 'NOT successPaiement'}
            {success?'success': 'NOT success'}
            {lienInvalide?'lienInvalide': 'NOT lienInvalide'}
            {lienValide?'lienValide': 'NOT lienValide'}
            {editedAdherent && editedAdherent.civilite?'editedAdherent.civilite': 'NOT editedAdherent.civilite'} */}
            {/* edited = {editedAdherent? JSON.stringify(editedAdherent) : ''} - {code} - {mail}<br />
            saved = {savedAdherent? JSON.stringify(savedAdherent) : ''}  */}

            {(showTarifs && (editedAdherent.cotisation_nationale_t1 + (editedAdherent.has_tribu === 1 ? cotisation.tribu_montant : 0)) === 0) && <Alert variant='success'>
                Vos informations ont bien été prises en compte.<br />
                Bonne journée.
            </Alert>}
            {(successPaiement || (success && success === 'true')) && <Alert variant='success'>
                Votre paiement a bien été pris en compte.<br />
                Bonne journée.
            </Alert>}
            {!(successPaiement || (success && success === 'true')) && <>
                {success && success === 'false' && <Alert variant='danger'>
                    Votre paiement n'a pas été pris en compte.
                </Alert>}

                {/* {JSON.stringify(editedAdherent)} */}
                {/* Code : {code}<br />
            Mail : {mail}<br /> */}
                {lienInvalide && <Card bg="danger" text="white">
                    <Card.Header>Erreur</Card.Header>
                    <Card.Body>
                        <Card.Title>Lien invalide</Card.Title>
                        <Card.Text>
                            Le lien que vous avez utilisé n'est plus utilisable.
                        </Card.Text>
                    </Card.Body>
                </Card>}
                {!lienInvalide && lienValide && <>
                    {!(editedAdherent && editedAdherent.civilite) &&
                        <AdherentNewUpdate handleSaveAdherent={handleSaveAdherent} blocs={blocs}
                            champs={champs} cotisation={cotisation} cotisation2={cotisation2} setCotisation={setCotisation}
                            setCotisation2={setCotisation2} code={code} choix_id={cotisation.id === 10 ? 35 : ''} adherent={savedAdherent} />}
                    {savedAdherent && !payeByCheque && !payeByVirement && showTarifs &&
                        (editedAdherent.cotisation_nationale_t1 +
                            (editedAdherent.has_tribu === 1 ? cotisation.tribu_montant : 0) +
                            (editedAdherent.has_siv === 1 ? cotisation.siv_montant : 0)
                        ) > 0 && editedAdherent.civilite && <><Button onClick={modifAdherent}>← Modifier</Button><br /><br /></>}
                    {!payeByCheque && !payeByVirement && showTarifs &&
                        (editedAdherent.cotisation_nationale_t1 +
                            (editedAdherent.has_tribu === 1 ? cotisation.tribu_montant : 0) +
                            (editedAdherent.has_siv === 1 ? cotisation.siv_montant : 0) 
                        ) > 0 && editedAdherent.civilite && <Tarif cotisation={cotisation}
                            prix={editedAdherent.cotisation_nationale_t1 +
                                (editedAdherent.has_tribu === 1 ? cotisation.tribu_montant : 0)
                                + (editedAdherent.has_siv === 1 ? cotisation.siv_montant : 0)
                            } code={code} mail={mail} handleTarifSelected={handleTarifSelected} />}
                    {prelevementSelected.nb > 0 && <PrelevementSepaForm nb_fois={prelevementSelected.nb} code={code} setSuccessPaiement={setSuccessPaiement} />}
                    <GenerePdf fichier='feuille' data={editedAdherent} go={goGenerePdf} setGo={setGoGenerePdf} visible={false} />

                    {/* <GenerePdf fichier='feuille' data={editedAdherent} go={goGenerePdf} setGo={setGoGenerePdf} visible={false} /> */}

                    {payeByCheque && <Card>
                        <Card.Header>Paiement par chèque</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <div className='center'>
                                    Nous vous prions de bien vouloir imprimer le document qui vous a été transmis par courriel, puis de procéder à l'envoi d'un chèque d'un montant de {editedAdherent.montant_total} €, établi à l'ordre de la FFC – MOBILITE.<br /><br />
                                    Veuillez retourner le bulletin dûment rempli à l'adresse suivante :<br /><br />
                                    FFC Mobilité - Immeuble Le Cardinet – 8, rue Bernard Buffet – 75017 PARIS.
                                    {/* <GenerePdf fichier='feuille' data={editedAdherent} visible={true} /> */}
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>}

                    {payeByVirement && <Card>
                        <Card.Header>Paiement par virement</Card.Header>
                        <Card.Body>
                            <Card.Text>
                                <div className='center'>
                                    Nous vous prions de bien vouloir procéder à un virement d'un montant de {editedAdherent.montant_total} € sur le Relevé d'Identité Bancaire (RIB) du compte ci-dessous :<br />
                                    <Image src={rib} /><br /><br />
                                    Ces informations vous ont été envoyées par mail.<br />
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>}

                </>}
            </>}
        </div>
    );
}

export default Adhere;
